import React from "react";
import { useTheme } from "@mui/material/styles";

/**
 * Injects the handful of theme-driven CSS vars that App.css / legacy component
 * CSS still read. Only the three consumed vars are set here — the previous
 * ~12-var block was almost entirely dead (grep-verified zero consumers).
 * The editorial theme is otherwise owned by Tailwind tokens + index.css.
 */
const ThemeVariables = ({ children }) => {
  const theme = useTheme();

  const style = {
    "--bg-color": theme.palette.primary.bgColor, // App.css .App background
    "--black": theme.palette.primary.black, // UploadModel.css
    "--text-form-label": theme.palette.text.secondary, // App.css <label>
  };

  return <div style={style}>{children}</div>;
};

export default ThemeVariables;
